<template>
  <div class="vx-col w-full">
    <eod-question-sidebar
      :question="selectedQuestion"
      :active="isSidebarOpen"
      :isEditable="isEditable"
      :countryName="countryName"
      @update:question="updateQuestion"
      @delete:question="deleteQuestion"
      @update:active="isSidebarOpen = $event"
    />

    <vx-card class="mb-5" title="Questions" collapse-action>
      <div class="px-3 mt-4">
        <draggable
          tag="ul"
          :disabled="!isEditable"
          class="draggable-list"
          ghost-class="moving-card"
          filter=".action-button"
          :list="template.questions"
          :animation="200"
        >
          <li
            v-for="question in template.questions"
            :key="question.id"
            class="p-4 mb-3 flex justify-between items-center border border-light-grey rounded-lg cursor-move"
            style="background-color: #f8fafb"
            @click="handleQuestionClick(question)"
          >
            <div class="flex items-center">
              <feather-icon
                icon="MenuIcon"
                svgClasses="h-3 w-3"
                class="mr-5 p-1"
              />
              <feather-icon
                :icon="getIconForType(question.type)"
                svgClasses="h-4 w-4"
                class="p-2 inline-flex rounded-md bg-white border border-light-grey shadow"
              />
              <div class="ml-4">
                <p class="text-gray-700 font-semibold font-sans tracking-wide">
                  {{ question.title || "(Untitled)" }}
                </p>
                <p v-if="question.venueIds && question.venueIds.length > 0" class="text-sm text-primary">
                  Venue filter: {{ question.venueIds.length }} venue(s)
                </p>
              </div>
            </div>
            <div class="flex">
              <button
                aria-label="Edit question"
                class="action-button p-1 focus:outline-none focus:shadow-outline text-gray-600 hover:text-teal-600"
                @click.stop="handleQuestionClick(question)"
              >
                <feather-icon
                  icon="EditIcon"
                  svgClasses="h-5 w-5"
                  class="p-1 inline-flex"
                />
              </button>
            </div>
          </li>
        </draggable>

        <vs-dropdown v-if="isEditable" class="cursor-pointer flex" :vs-trigger-click="true" vs-custom-content>
          <div class="cursor-pointer">
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">New question</span>
          </div>
          <vs-dropdown-menu style="z-index: 200001">
            <vs-dropdown-item
              v-for="(typeInfo, typeKey) in questionTypeMap"
              :key="typeKey"
              @click.stop="addQuestion(typeKey)"
              class="px-0 py-2"
            >
              <feather-icon
                :icon="typeInfo.icon"
                class="p-2 inline-flex rounded-lg bg-white border border-solid border-grey shadow"
                svgClasses="h-5 w-5"
              />
              <span class="ml-3">{{ typeInfo.name }}</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
    </vx-card>

    <vs-row vs-justify="space-between" class="flex flex-wrap items-center" style="margin-top: 32px">
      <vs-button v-if="isEditable" @click="$emit('save')">Save</vs-button>
    </vs-row>
  </div>
</template>

<script>
import Draggable from "vuedraggable";
import EodQuestionSidebar from "./EodQuestionSidebar.vue";

export default {
  components: { Draggable, EodQuestionSidebar },
  data() {
    return {
      selectedQuestion: null,
      isSidebarOpen: false,
    };
  },
  props: {
    template: { type: Object, required: true },
    isEditable: { type: Boolean, default: false },
    countryName: { type: String, default: null },
  },
  computed: {
    questionTypeMap() {
      return this.$store.getters["eodTemplates/questionTypeMap"];
    },
  },
  methods: {
    getIconForType(type) {
      var map = this.questionTypeMap;
      return (map[type] && map[type].icon) || "HelpCircleIcon";
    },
    async addQuestion(type) {
      var newQuestion = await this.$store.dispatch("eodTemplates/createQuestion", type);
      this.template.questions.push(newQuestion);
      this.handleQuestionClick(newQuestion);
    },
    handleQuestionClick(question) {
      this.selectedQuestion = JSON.parse(JSON.stringify(question));
      this.isSidebarOpen = true;
    },
    updateQuestion() {
      var idx = this.template.questions.findIndex(function(q) { return q.id === this.selectedQuestion.id; }.bind(this));
      if (idx >= 0) {
        this.template.questions.splice(idx, 1, JSON.parse(JSON.stringify(this.selectedQuestion)));
      }
      this.selectedQuestion = null;
    },
    deleteQuestion() {
      var self = this;
      this.template.questions = this.template.questions.filter(function(q) {
        return q.id !== self.selectedQuestion.id;
      });
      this.selectedQuestion = null;
      this.isSidebarOpen = false;
    },
  },
};
</script>

<style scoped lang="css" src="@/assets/css/tailwind.min.css"></style>

<style scoped>
.draggable-list {
  min-height: 100px;
  list-style: none;
  padding: 0;
}
.moving-card {
  opacity: 0.5;
  background: #f7fafc;
  border: 1px dashed #4299e1;
}
</style>
